"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterStateRecord = exports.CategorizerStateRecord = void 0;
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var types_1 = require("./types");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var _a = core_1.default.utils, isInnerPage = _a.isInnerPage, getFiltersFromLocation = _a.getFiltersFromLocation;
exports.CategorizerStateRecord = immutable_1.Record({
    items: [],
    fetchStatus: core_1.App.FetchStatus.INITIAL,
    isOpen: false,
    openedGameIds: [],
    fixedTournamentIds: [],
}, 'CategorizerState');
exports.FilterStateRecord = immutable_1.Record({
    categorizer: new exports.CategorizerStateRecord(),
    isOpen: false,
}, 'FilterState');
var initialState = new exports.FilterStateRecord();
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case constants_1.GET_CATEGORIZER_REQUEST: {
            var nextCategorizer = state.categorizer.set('fetchStatus', core_1.App.FetchStatus.LOADING);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.GET_CATEGORIZER_SUCCESS: {
            var data = action.payload.data;
            var nextCategorizer = state.categorizer
                .set('items', data.categorizer)
                .set('fetchStatus', core_1.App.FetchStatus.LOADED);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.GET_CATEGORIZER_FAIL: {
            var nextCateogrizer = state.categorizer.set('fetchStatus', core_1.App.FetchStatus.FAILED);
            return state.set('categorizer', nextCateogrizer);
        }
        case constants_1.TOGGLE_FILTERS: {
            return state.set('isOpen', !state.isOpen);
        }
        case constants_1.OPEN_CATEGORIZER: {
            if (state.categorizer.isOpen)
                return state;
            var nextCategorizer = state.categorizer.set('isOpen', true);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.CLOSE_CATEGORIZER: {
            if (!state.categorizer.isOpen)
                return state;
            var nextCategorizer = state.categorizer.set('isOpen', false);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.CHANGE_FIXED_TOURNAMENTS: {
            var fixedTournamentIds = action.payload.fixedTournamentIds;
            var nextCategorizer = state.categorizer.set('fixedTournamentIds', lodash_1.xor(state.categorizer.fixedTournamentIds, fixedTournamentIds));
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.SELECT_GAME: {
            var _a = action.payload, gameId = _a.gameId, type = _a.type, nextTournamentIds = _a.nextTournamentIds;
            var nextOpenedGameIds = state.categorizer.openedGameIds;
            if (type === types_1.CheckGameType.Close) {
                nextOpenedGameIds = lodash_1.xor(state.categorizer.openedGameIds, [
                    gameId,
                ]);
            }
            else {
                nextOpenedGameIds = utils_1.getOpenedGameIds(state.categorizer.items, lodash_1.xor(state.categorizer.openedGameIds, [gameId]), nextTournamentIds, state.categorizer.fixedTournamentIds);
            }
            var nextCategorizer = state.categorizer.set('openedGameIds', nextOpenedGameIds);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.UNSELECT_GAMES_WITHOUT_SELECTED_TOURNAMENTS: {
            var items = state.categorizer.items;
            var _b = getFiltersFromLocation().tournamentIds, tournamentIds = _b === void 0 ? [] : _b;
            var nextOpenedGameIds = utils_1.getOpenedGameIds(items, [], tournamentIds, []);
            var nextCategorizer = state.categorizer.set('openedGameIds', nextOpenedGameIds);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.RESET_CATEGORIZER_CONTROL_FIELDS: {
            var nextCategorizer = state.categorizer
                .set('openedGameIds', [])
                .set('fixedTournamentIds', []);
            return state.set('categorizer', nextCategorizer);
        }
        case constants_1.INIT_CATEGORIZER_CONTROLS_BY_LOCATION: {
            var nextOpenedGameIds = state.categorizer.openedGameIds;
            var nextFixedTournamentIds = state.categorizer.fixedTournamentIds;
            if (isInnerPage()) {
                nextOpenedGameIds = [];
                nextFixedTournamentIds = [];
            }
            else {
                var _c = getFiltersFromLocation().tournamentIds, tournamentIds_1 = _c === void 0 ? [] : _c;
                nextOpenedGameIds = utils_1.getOpenedGameIds(state.categorizer.items, [], tournamentIds_1, state.categorizer.fixedTournamentIds);
                nextFixedTournamentIds = state.categorizer.fixedTournamentIds.filter(function (fId) { return tournamentIds_1.includes(fId); });
            }
            var nextCategorizer = state.categorizer
                .set('openedGameIds', nextOpenedGameIds)
                .set('fixedTournamentIds', nextFixedTournamentIds);
            return state.set('categorizer', nextCategorizer);
        }
        default:
            return state;
    }
}
exports.default = reducer;
//# sourceMappingURL=reducer.js.map